// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 351 ? "commons" : chunkId) + "." + {"37":"23b4b23d4b8a192599e1","191":"a3051e774097bddcda90","254":"6331f2e7f6801cbb6ee9","351":"cf1cbdbde6bb3bf3077d","358":"25f5f4da6015c98ce16f","631":"771d9c6eb71884d57556","637":"f91d2dc878cef3469783"}[chunkId] + ".js";
};